export interface TtsVoice {
  id: string;
  short: string;
  azure: string;
  label: string;
}

export interface TtsManifest {
  voices: TtsVoice[];
  items: Record<string, string[]>;   // cardId → list of voice shorts ("iselin", "pernille"...)
}

let cache: TtsManifest | null = null;
let loadPromise: Promise<TtsManifest> | null = null;

export function loadTtsManifest(): Promise<TtsManifest> {
  if (cache) return Promise.resolve(cache);
  loadPromise ??= fetch('/data/tts-manifest.json')
    .then((r) => r.ok ? r.json() : { voices: [], items: {} })
    .then((m) => { cache = m as TtsManifest; return cache; })
    .catch(() => { cache = { voices: [], items: {} }; return cache; });
  return loadPromise;
}

export function ttsUrls(manifest: TtsManifest, cardId: string): string[] {
  const voices = manifest.items[cardId];
  if (!voices?.length) return [];
  return voices.map((v) => `/audio/tts/${v}/${cardId}.mp3`);
}

export function ttsCoverage(manifest: TtsManifest): number {
  return Object.keys(manifest.items).length;
}
